import React, { FC } from 'react';
// import { NavBar } from '../../nav';

export const View: FC = ({ children }) => {
	return <>{children}</>;
	// return <NavBar>{children}</NavBar>;
};
